import { BoardSize } from 'chessboard/plugins/board-size/config/types';
import { Core } from 'chessboard/core/config/types';
import type { Plugins } from 'chessboard/core/plugins/config/types';
import { isOneOf } from 'src/utils/app/model/is-one-of';

/**
 * Helper for sizing the board.
 */
export function createBoardSizePlugin(): Plugins.Model {
  return {
    match: [
      {
        condition: isOneOf([Core.UIEvents.Resize, Core.InstanceEvents.RendererSet]),
        handler: resize,
      },
    ],
    name: BoardSize.Plugin.Name,
  };

  /**
   * Resize the board.
   */
  function resize(_event: Core.Event, context: Core.Context): void {
    const { renderer } = context;

    renderer?.resize(context);
  }
}
